const isDev = process.env.REACT_APP_MODE === 'development'
const isProd = process.env.REACT_APP_MODE === 'production'

const environment = {
  isDevMode: isDev,
  isProdMode: isProd,
  thirdWebClientId: process.env.REACT_APP_PUBLIC_THIRDWEB_CLIENT_ID,
  appApiUrl: process.env.REACT_APP_APP_API_URL,
  subgraphApiKey: process.env.REACT_APP_SUBGRAPH_API_KEY,
  alchemyApiKey: '7XnSXbVD19aQb8B3IKzkFPYGXPgI2JAN',
}

export default environment
